import {Template} from '../shared/render/template.interface';
import {TooltipNode} from './model/tooltip-node.model';

export class TooltipTemplate implements Template {
    container: HTMLElement;
    content: HTMLElement;

    constructor(
        private document: Document,
        private tooltipNode: TooltipNode
    ) {
        this.initContainer();
        this.initContent();
    }

    setContent(): void  {
        this.content.innerHTML = this.tooltipNode.content;
    }

    private initContainer(): void {
        this.container = this.document.createElement('div');
        this.container.setAttribute('role', 'tooltip');
        this.container.classList.add('tooltip', 'ivy-tooltip', 'fade', 'show');
        this.container.tabIndex = -1;
    }

    private initContent(): void {
        this.content = this.document.createElement('div');
        this.content.classList.add('tooltip-inner', 'ivy-tooltip-inner');
        this.setContent();
        this.container.appendChild(this.content);
    }
}